import { Text, View } from '@react-pdf/renderer';
import React from "react";
import { DashboardQuery } from "../../../types/files";
import ExportQuery from "../dashboard-queries-export/ExportQuery";
import styles from "./styles";

const PDFDashboardQueries: React.FC<{ queries: DashboardQuery[] }> = ({ queries }) => {
    return (<>
        <View style={styles.contentBlock}>
            <Text style={styles.title}>
                {'Company details'}
            </Text>
            <View style={styles.queries}>
                {queries.map((query, i) => (
                    <View style={styles.query} key={'pdf-body-22-' + i}>
                        <Text style={styles.queryTitle}>
                            {query.title}
                        </Text>
                        <View style={styles.queryAnswer}>
                            <ExportQuery query={query} />
                        </View>
                    </View>
                ))}
            </View>
        </View>
    </>);
}

export default PDFDashboardQueries;